export const JOTFORM_IDS = {
    CORRETOR_REDACAO: '251112651775353',
    AJUDANTE_TPC: '251172555758363',
    EXERCISES: '251171942712352',
    PLANO_ESTUDOS_MODAL: '252114480104342',
    SIMULADOR_SISU: '253215399530357'
}

export function checkMustShowFormId(formId: string) {
    return localStorage.getItem('mustShowForm_'+formId) === 'true';
}
export function setMustShowFormId(formId: string) {
    localStorage.setItem('mustShowForm_'+formId, 'true');
}

export function removeMustShowFormId(formId: string) {
    localStorage.removeItem('mustShowForm_'+formId);
}
export function showJotForm(formId: string, user_id: string = '', user_email: string = '', title: string = 'Toda Matéria') {
    // Create and append the feedback script
    const feedbackScript = document.createElement('script');
    feedbackScript.src = 'https://form.jotform.com/static/feedback2.js';
    feedbackScript.type = 'text/javascript';

    // Create and append the form embed handler script
    const embedHandlerScript = document.createElement('script');
    embedHandlerScript.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';

    // Load feedback script first
    feedbackScript.onload = () => {
        // After feedback script loads, load the embed handler
        document.head.appendChild(embedHandlerScript);

        embedHandlerScript.onload = () => {
            // After both scripts are loaded, create the form
            const initScript = document.createElement('script');
            initScript.type = 'text/javascript';
            initScript.text = `
                var JFL_${formId} = new JotformFeedback({
                    formId: '${formId}',
                    base: 'https://form.jotform.com/',
                    windowTitle: '${title}',
                    backgroundColor: '#522e91',
                    fontColor: '#FFFFFF',
                    type: '1',
                    height: 'auto',
                    width: 700,
                    openOnLoad: true,
                    iframeParameters: {
                        user_id: '${user_id}',
                        user_email: '${user_email}',
                    },
                });
            `;
            document.head.appendChild(initScript);

            // Create and append the embed handler initialization script
            const embedInitScript = document.createElement('script');
            embedInitScript.text = `window.jotformEmbedHandler("iframe[id='${formId}']", "https://form.jotform.com/")`;
            document.head.appendChild(embedInitScript);
        };
    };

    // Start the loading process
    document.head.appendChild(feedbackScript);
    
    removeMustShowFormId(formId);
}
